import React from "react";
import { useStyle } from "./styles";
import { BrandsProps } from "./types";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const Brands = (props: BrandsProps) => {
  const classes = useStyle();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: props.lgItemsCount ? props.lgItemsCount : 8,
      partialVisibilityGutter: 40
    },
    tablet: {
      breakpoint: { max: 1200, min: 600 },
      items: props.mdItemsCount ? props.mdItemsCount : 5,
      partialVisibilityGutter: 30
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: props.smItemsCount ? props.smItemsCount : 3,
      partialVisibilityGutter: 30
    },
  };

  const settings = {
    additionalTransfrom: 0,
    centerMode: false,
    arrows: false,
    swipeable: false,
    draggable: false,
    showDots: false,
    responsive: responsive,
    infinite: true,
    autoPlay: true,
    autoPlaySpeed: 2000,
    showThumbs: false,
    slidesToSlide: 1
  };

  return (
    <section className={classes.brandContainer}>
      {props.title && <div className={"h2 " + classes.brandTitle}>{props.title}</div>}
      <div className="carousel-wrapper">
        <Carousel {...settings}>
          {props.items.map((el, idx) => (
              <span className="carousel-item" key={idx}>{el}</span>
          ))}
        </Carousel>
      </div>
    </section>
  );
};
